<template>
  <div class="who" id="about">
    <div class="container">
      <div class="who__wrapper">
        <h2 class="who__title">What is <span>ALCOR INNOVATIVE ?</span></h2>
        <p class="who__text">At ALCOR INNOVATIVE LTD S.R.L., we transform ideas into impactful brand experiences. We are a full-service marketing partner committed to empowering businesses to grow, connect, and thrive. Our specialists craft tailored digital campaigns, build strong brand identities, and manage social media with precision and creativity. Driven by innovation, strategic insight, we help companies of all sizes break through the noise and leave a lasting impression. Ready to reimagine your marketing potential? Partner with us and start creating your future today.</p>
        <div class="who__images">
          <img src="@images/whoImage1.png" alt="image">
          <img src="@images/whoImage2.png" alt="image">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.who {
  padding-top: 100px;

  &__title {
    color: #2F327D;
    text-align: center;
    font-size: 44px;
    font-weight: 600;
    line-height: 180%;

    & span {
      color: #F48C06;
    }
  }

  &__text {
    margin-top: 25px;
    color: #696984;
    text-align: center;
    font-size: 24px;
    font-weight: 400;
    line-height: 180%;
    letter-spacing: 0.48px;
  }

  &__images {
    margin-top: 40px;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
}

@media (max-width: 1300px) {
  .who {
    &__text {
      font-size: 16px;
    }

    &__images {
      & img {
        width: 45%;
      }
    }
  }
}

@media (max-width: 650px) {
  .who {
    &__title {
      font-size: 24px;
      line-height: 28px;
    }

    &__text {
      font-size: 12px;
    }

    &__images {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;

      & img {
        width: 80%;
      }
    }
  }
}
</style>